/**
 * @description i18n en
 * @author wangfupeng
 */

export default {
  // 通用的词
  common: {
    ok: 'OK',
    delete: 'Delete',
    enter: 'Enter',
  },

  blockQuote: {
    title: 'Quote',
  },
  codeBlock: {
    title: 'Code block',
  },
  color: {
    color: 'Font color',
    bgColor: 'Back color',
    default: 'Default color',
    clear: 'Clear back color',
  },
  divider: {
    title: 'Divider',
  },
  emotion: {
    title: 'Emotion',
  },
  fontSize: {
    title: 'Font size',
    default: 'Default',
  },
  fontFamily: {
    title: 'Font family',
    default: 'Default',
  },
  fullScreen: {
    title: 'Full screen',
    cancelTitle: 'Cancel full screen',
  },
  header: {
    title: 'Header',
    text: 'Text',
  },
  image: {
    netImage: 'Net image',
    delete: 'Delete image',
    edit: 'Edit image',
    editSize: 'Edit size',
    preview: 'Preview image',
    viewLink: 'View link',
    src: 'Image src',
    desc: 'Description',
    link: 'Image link',
    ok: 'Ok',
    width: 'Width',
    height: 'Height',
  },
  indent: {
    decrease: 'Decrease',
    increase: 'Increase',
  },
  justify: {
    left: 'Left',
    right: 'Right',
    center: 'Center',
    justify: 'Justify',
  },
  lineHeight: {
    title: 'Line height',
    default: 'Default',
  },
  link: {
    insert: 'Insert link',
    text: 'Link text',
    url: 'Link source',
    unLink: 'Unlink',
    edit: 'Edit link',
    view: 'View link',
  },
  textStyle: {
    bold: 'Bold',
    clear: 'Clear styles',
    code: 'Inline code',
    italic: 'Italic',
    sub: 'Sub',
    sup: 'Sup',
    through: 'Through',
    underline: 'Underline',
  },
  undo: {
    undo: 'undo',
    redo: 'Redo',
  },
  todo: {
    todo: 'Todo',
  },
  formatPainter: {
    title: 'Format Painter',
  },
}
